import api from './api';

export interface WCMatch {
  id: number;
  api_match_id: number;
  stage: string;
  bracket_pos: number;
  home_team: string | null;
  away_team: string | null;
  kickoff_utc: string;
  home_score: number | null;
  away_score: number | null;
  penalty_home_score: number | null;
  penalty_away_score: number | null;
  winner: string | null;
  status: string;
}

export interface WCPrediction {
  id: number;
  match_id: number;
  home_score_pred: number;
  away_score_pred: number;
  advancing_team: string;
  submitted_at: string | null;
  updated_at: string | null;
  locked_at: string | null;
}

export interface WCRankingEntry {
  user_id: number;
  user_name: string;
  profile_picture?: string | null;
  points: number;
  exact_scores: number;
  score_error: number;
  champion_correct: boolean;
  rank: number;
}

export interface SavePredictionPayload {
  match_id: number;
  home_score_pred: number;
  away_score_pred: number;
  advancing_team: string;
}

export interface WCPredictorUser {
  user_id: number;
  user_name: string;
  profile_picture?: string | null;
  prediction_count: number;
}

export interface WCUserPredictionEntry {
  id: number;
  match_id: number;
  home_score_pred: number;
  away_score_pred: number;
  advancing_team: string;
  submitted_at: string | null;
  updated_at: string | null;
  match_stage: string;
  match_bracket_pos: number;
  home_team: string | null;
  away_team: string | null;
  kickoff_utc: string | null;
  home_score: number | null;
  away_score: number | null;
  penalty_home_score: number | null;
  penalty_away_score: number | null;
  winner: string | null;
  status: string;
  correct_winner: boolean | null;
  exact_score: boolean | null;
  points_earned: number | null;
}

export interface WCPredictionsOverview {
  user_id: number;
  user_name: string;
  profile_picture?: string | null;
  is_self: boolean;
  users: WCPredictorUser[];
  predictions: WCUserPredictionEntry[];
}

const wcService = {
  async getMatches(): Promise<WCMatch[]> {
    const res = await api.get('/wc/matches');
    return res.data.matches;
  },

  async getPredictions(): Promise<WCPrediction[]> {
    const res = await api.get('/wc/predictions');
    return res.data.predictions;
  },

  async savePredictions(predictions: SavePredictionPayload[]): Promise<void> {
    await api.post('/wc/predictions', predictions);
  },

  async getPredictionsOverview(userId?: number): Promise<WCPredictionsOverview> {
    const res = await api.get('/wc/predictions/overview', {
      params: userId ? { user_id: userId } : undefined,
    });
    return res.data;
  },

  async getLeaderboard(): Promise<WCRankingEntry[]> {
    const res = await api.get('/wc/leaderboard');
    return res.data.leaderboard;
  },

  async syncMatches(): Promise<{ status: string; message: string }> {
    const res = await api.post('/wc/sync');
    return res.data;
  },
};

export default wcService;
